import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useLeaderboardModal from '../hooks/useLeaderboardModal';
import EditLeaderboardModal from './EditLeaderboardModal';
import DownloadBoardModal from './DownloadBoardModal';
import BoardSettingsModal from './BoardSettingsModal';
import AddBoardModal from './AddBoardModal';
import SaveDeleteTemplateModal from './SaveDeleteTemplateModal';

import SharedModal from '../../../shared/_TBComponents/Modal';

import { deleteTemplate, fetchGroups } from '../ducks/leaderboardActions';

const getModalMinHeight = (activeModal) => {
  if (activeModal === 'Delete Template' || activeModal === 'Leaderboard Settings' || activeModal === 'Export Leaderboard') return 'auto';
  return '400px';
};

const getModalMaxWidth = (activeModal) => {
  if (activeModal === 'Save as Template') return '480px';
  if (activeModal === 'Delete Template') return '480px';
  if (activeModal === 'Export Leaderboard') return '480px';
  if (activeModal === 'Edit Leaderboard' || activeModal === 'Edit Template') return '800px';
  return '710px';
};

const LeaderboardModal = () => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const leaderboardsReference = useSelector(
    (state) => state.leaderboard.data.leaderboardsReference,
  );
  const dispatch = useDispatch();

  const {
    activeBoardId,
    activeModal,
    isModalOpen,
    handleSetModalOpen,
  } = useLeaderboardModal();

  const boardKeys = Object.keys(leaderboardsReference);
  const boardNumber = ['Leaderboard Settings', 'Export Leaderboard', 'Edit Leaderboard', 'Save as Template'].includes(activeModal) && boardKeys.length > 1
    ? boardKeys.indexOf(String(activeBoardId)) + 1
    : 0;

  const { accountCode } = currentUser;

  const closeModal = () => {
    handleSetModalOpen(false, '');
  };

  useEffect(() => {
    if (isModalOpen) {
      dispatch(fetchGroups(accountCode));
    }
  }, [isModalOpen]);

  return (
    <SharedModal
      customBorderRadius='8px'
      customButton
      customMaxWidth={getModalMaxWidth(activeModal)}
      customMinHeight={getModalMinHeight(activeModal)}
      customPadding='0px'
      hideTitle
      isOpen={isModalOpen}
      onRequestClose={closeModal}
    >
      {activeModal === 'Add Leaderboard' && (
        <AddBoardModal closeModal={closeModal} />
      )}
      {activeModal === 'Create Leaderboard' && (
        <AddBoardModal startInCreate closeModal={closeModal} />
      )}
      {activeModal === 'Edit Leaderboard' && (
        <EditLeaderboardModal
          boardNumber={boardNumber}
          editContext='board'
          entityId={activeBoardId}
          closeModal={closeModal}
        />
      )}
      {activeModal === 'Edit Template' && (
        <EditLeaderboardModal
          editContext='template'
          entityId={activeBoardId}
          closeModal={closeModal}
        />
      )}
      {activeModal === 'Export Leaderboard' && (
        <DownloadBoardModal
          boardNumber={boardNumber}
          closeModal={closeModal}
          leaderboardId={activeBoardId}
        />
      )}
      {activeModal === 'Leaderboard Settings' && (
        <BoardSettingsModal
          boardNumber={boardNumber}
          closeModal={closeModal}
          leaderboardId={activeBoardId}
        />
      )}
      {activeModal === 'Save as Template' && (
        <SaveDeleteTemplateModal
          boardNumber={boardNumber}
          leaderboardId={activeBoardId}
          title='Save as Template'
          closeModal={closeModal}
        />
      )}
      {activeModal === 'Delete Template' && (
        <SaveDeleteTemplateModal
          templateId={activeBoardId}
          title='Delete Template'
          closeModal={closeModal}
          intro='You are about to delete this leaderboard. This action cannot be undone.'
          primaryLabel='Delete'
          primaryDanger
          onPrimary={() => {
            dispatch(deleteTemplate(activeBoardId));
            closeModal();
          }}
          secondaryLabel='Cancel'
        />
      )}
    </SharedModal>
  );
};

export default LeaderboardModal;
